<template>
  <div id="app">
    <div>
      <header-component />

      <div class="browser">
        <div class="browser-panel">
          <svgicon name="browser-buttons" width="42px" height="11px" :original="true"></svgicon>
        </div>
        <div class="browser-body">
          <button-back :currentStep="currentStep" class="button-back" />
          <transition name="fade-tooltip" appear mode="out-in">
            <tooltip :key="currentStep" :currentStep="currentStep" class="tooltip" ref="tooltip"/>
          </transition>
          <transition :name="transitionName" mode="out-in">
            <router-view class="router-view"></router-view>
          </transition>
        </div>
      </div>

      <footer-component />
    </div>
  </div>
</template>

<script>
import '@/assets/compiled-icons';
import ButtonBack from '@/components/ButtonBack';
import HeaderComponent from '@/components/Header';
import FooterComponent from '@/components/Footer';
import Tooltip from '@/components/Tooltip';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    ButtonBack,
    FooterComponent,
    Tooltip
  },
  data() {
    return {
      currentStep: '',
      transitionName: 'slide-left'
    }
  },
  mounted() {
    if (this.$route) {
      return this.currentStep = this.$route.path;
    }
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/step')[1] || null;
      const fromDepth = from.path.split('/step')[1] || null;
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      return this.currentStep = this.$route.path;
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log(123);
    next()
  },
};
</script>

<style>
@import "./styles/application.css";
@import "./styles/colors.css";
@import "./styles/consts.css";

.browser {
  max-width: 1100px;
  min-height: 676px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 0 28px 18px -20px rgba(31, 31, 41, 0.05), 0 2px 3px 0 rgba(31, 31, 41, 0.18);
}

.browser-panel {
  width: 100%;
  height: 45px;
  display: flex;
  padding-left: 16px;
  align-items: center;
  background-color: #f3f6f6;
  position: relative;
}

.browser-panel::after {
  position: absolute;
  top: 13px;
  right: 84px;
  content: '';
  background-color: $white;
  width: 942px;
  height: 20px;
  border-radius: 15px;
  opacity: 0.7;
  margin-left: 28px;
}

.browser-body {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  background-color: $white;
}

.button-back {
  @include proxima_light;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  color: $pastel-gray;
  cursor: pointer;
  position: absolute;
  top: 39px;
  left: 54px;
  z-index: 10;
}

.tooltip {
  position: absolute;
  top: 187px;
  right: -124px;
}
/* Transition on change route */
.router-view {
  position: absolute;
  transition: all 0.5s cubic-bezier(.15,0,.5,1);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  transform: translate(50px, 0);
}

.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  transform: translate(-50px, 0);
}

/* Tooltip fade animation */
.fade-tooltip-enter-active {
  transition: opacity 1.3s ease;
  transition-delay: 1.5s;
}

.fade-tooltip-leave-active {
  transition: opacity 0.3s ease;
}

.fade-tooltip-enter, .fade-tooltip-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue